import { Button, Dialog, Divider } from "@rio-cloud/rio-uikit";

interface IInfoDialogProps {
    show: boolean;
    title: string;
    body: string;
    onClose: () => void;
}

const InfoDialog = ({ show, title, body, onClose }: IInfoDialogProps) => {
    return (
        <Dialog
            show={show}
            title={(
                <div className="">
                    <span className="rioglyph rioglyph-info-sign margin-right-10 text-color-info" />
                    <span>{title}</span>
                </div>
            )}
            footer={
                <>
                    <div className='display-flex justify-content-end'>
                        <Button bsStyle='default' onClick={onClose} className="margin-right-10">
                            Fechar
                        </Button>
                    </div>
                </>
            }
            body={body}
            bsSize={Dialog.SIZE_XS}
            onClose={onClose}
        />
    );
}

export default InfoDialog;